/**
 *
 * Asynchronously loads the component for PracticePage
 *
 */

import loadable from "@loadable/component";

export default loadable(() => import("./PracticePage"));
